// App.js

import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import RadioPlayer from "./components/RadioPlayer";// This will include all the other sections
import MainPage from "./pages/MainPage";

function App() {
  return (
    <Router>
      <Routes>
        {/* Landing Page with Radio Player */}
        <Route path="/" element={<RadioPlayer />} />

        {/* Main Page after entering */}
        <Route path="/main" element={<MainPage />} />
      </Routes>
    </Router>
  );
}

export default App;
